import { Collection, Plugin } from 'ckeditor5';
export class PlaceholderStore extends Plugin {
    static get pluginName() {
        return 'PlaceholderStore';
    }
    init() {
        this.placeholderData = new Collection();
        this.registerPlaceholders();
    }
    registerPlaceholders() {
        const { conversion } = this.editor;
        // Register all placeholders in to the store when editor loads HTML
        conversion.for('upcast').add((dispatcher) => {
            dispatcher.on('element:span', (_, data) => {
                const { viewItem } = data;
                const name = viewItem.getAttribute('data-placeholder');
                if (name) {
                    this.addPlaceholderToStore(name);
                }
            });
        });
        // Register all placeholders in to the store when editor inserts a new placeholder
        conversion.for('downcast').add((dispatcher) => {
            dispatcher.on('insert:placeholder', (_, data) => {
                const { item } = data;
                const id = item.getAttribute('id');
                if (id) {
                    this.addPlaceholderToStore(id);
                }
            });
        });
    }
    addPlaceholderToStore(id) {
        const exists = this.placeholderData.has(id);
        if (exists) {
            return;
        }
        this.placeholderData.add({ id });
    }
    getPlaceholderFromStore(id) {
        return this.placeholderData.get(id);
    }
    getAllPlaceholdersFromStore() {
        return this.placeholderData.map(({ id }) => id);
    }
}
